import { render, staticRenderFns } from "./DashboardCalendar.vue?vue&type=template&id=58905d8e&scoped=true&"
import script from "./DashboardCalendar.vue?vue&type=script&lang=ts&"
export * from "./DashboardCalendar.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardCalendar.vue?vue&type=style&index=0&id=58905d8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58905d8e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCalendar } from 'vuetify/lib/components/VCalendar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCalendar,VCard,VIcon})
